import { render, staticRenderFns } from "./RegisteredMasters.vue?vue&type=template&id=f12a55bc&"
import script from "./RegisteredMasters.vue?vue&type=script&lang=js&"
export * from "./RegisteredMasters.vue?vue&type=script&lang=js&"
import style0 from "./RegisteredMasters.vue?vue&type=style&index=0&id=f12a55bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports